<template>
  <b-overlay
    :show="show && !$store.state.auth.isProfileCalled"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card>
      <GetDescription name="top-dashboard-description" />

      <div v-if="!show && $store.state.auth.isProfileCalled">
        <b-row class="d-flex flex-wrap flex-column justify-content-center align-items-center">
          <b-col
            md="12"
            sm="12"
            class=""
          >
            <div
              style="height: 100%;"
              class=""
            >
              <DashboardAlert
                :title="$t('suggest-active-two-factore-login-message')"
                :variant="'info'"
                :btn-text="$t('activate')"
                :btn-to="'/'+this.$i18n.locale+'/profile/security'"
                :btn-target="'_self'"
              />
            </div>
            <div class="mt-3">
              <div
                v-for="card in cardsArray"
                :key="card.title"
                class="mt-1"
                :class="(card.total_pending && card.total_pending !=0 )||( card.cardType && card.cardType == 'document' &&
                  (card.status == 'pending' || card.status == 'rejected'))?'w-100':''"
              >
                <div
                  v-if="(card.total_pending && card.total_pending !=0 )||( card.cardType && card.cardType == 'document' &&
                    (card.status == 'pending' || card.status == 'rejected'))"
                  class="w-100"
                  style="position: relative;height: 100%;"
                >
                  <DashboardAlert
                    :title="$t(card.title,{count:card.total_pending?card.total_pending:'',status:$t(card.status)})"
                    :description="$t(card.cardType && card.cardType == 'document'?(card.status == 'pending'?card.pendingDescription:card.rejectDescription):card.description)"
                    :variant="(card.cardType && card.cardType == 'document')?(card.status == 'pending'?'warning':'danger'):'info'"
                    :btn-text="$t('more_details')"
                    :btn-to="card.link"
                    :btn-target="'_self'"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="isUserActive && !user_complete"
          class="d-flex flex-wrap flex-column justify-content-center align-items-center"
        >
          <b-col
            md="8"
            sm="12"
            class="mt-1"
          >
            <b-card style="height:100%">
              <b-card-body class="p-0 card-center-content">
                <h4>{{ $t(cardInfo.nextStep.header) }}</h4>
                <p>{{ $t(cardInfo.nextStep.description) }}</p>
              </b-card-body>
              <div class="text-center">
                <b-button
                  class="p-2 px-4"
                  variant="success"
                  :to="cardInfo.nextStep.btn_link"
                >
                  {{ $t(cardInfo.nextStep.btn_text) }}
                </b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="isUserActive && user_complete && mergedObj.document&&( mergedObj.document.general.status != 'rejected' && mergedObj.document.general.status != 'pending') ">
          <b-col
            md="8"
            sm="12"
            class="mt-1 mx-auto"
          >
            <b-card style="height:100%">
              <b-card-body class="p-0 card-center-content">
                <h2>{{ $t('dashboard_page.user_complete_message') }}</h2>
                <p>{{ $t('dashboard_page.use_platform') }}</p>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </b-overlay>
</template>
<script>
import DashboardCompany from '@/views/logics/dashboard/DashboardCompany'
import DashboardAlert from './dashboardAlert.vue'

export default {
  components: { DashboardAlert },
  mixins: [DashboardCompany],
}
</script>
<style>
.card-center-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.buy-sell-btn{
  background-color: #f0c72b !important;
  border: none;
  color: #000 !important;
  animation: shake 10s infinite;
  animation-delay: 2s;

}
@keyframes shake {
  0% {
    transform: scale(1);
  }

  1% {
    transform: scale(1.2);
  }

  2% {
    transform: scale(1);
  }

  3% {
    transform: scale(1);
  }

  75% {
    transform: scale(1);
  }

  100% {
    transform: scale(1);
  }
}

.buy-sell-btn:focus {
  background-color:#f0c72b !important ;
}
</style>
